import { defineStore } from "pinia";

export const useWindowSizeStore = defineStore('windowSizeStore', {
  state : () => ({
    width : 0,
    height : 0,
  }),
  getters: {
    getWindowSize() {
      //console.log("************    get stored window size -- before return",this.width,this.height)
      return { width : this.width, height : this.height }
    }
  },
  actions: {
    updateStoredWindowSize(width, height) {
      //console.log("***** update stored window size ",width,height)
      this.width = width
      this.height = height
    },
  }

})
